/** NOTE: Keep map ordered by experiment id */
module.exports = {
    // // TODO Check Open Experiment Status
    CHAM_GOATS_POST_FMP_MORE_GIGS_V4: 4282,
    HAWKS_CONTINUE_CTA_COPY: 4366,
    HAWKS_DQA_INTEGRATION_FIRST_PHASE: 4879,
    HAWKS_ADD_TIMEOUT_TO_ADDITIONAL_DATA: 4932,
    CHEETAHS_MOBILE_GIG_PAGE: 5186,
    CROWS_DEFAULT_GIG_PRICE_DISPLAY: 5266,
    CHEETAHS_GIG_PAGE_BUTTONS_COLORS_V2: 5278,
};
